<template>
  <div>
    <div id="domId" class="model-css"></div>
  </div>
</template>

<script>
export default {
  name: 'model',
  data (){
    return {
      global: {}
    }
  },
  props: {
    query: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    renderModel () {
      // 初始化显示模型
      let options = new BimfaceSDKLoaderConfig()
      options.viewToken = this.global.viewToken
      console.log(this.global.viewToken)
      BimfaceSDKLoader.load(options, (viewMetaData) => {
        // 成功回调
        this.successCallback(viewMetaData).then(result => {
          // 存储二级弹窗需要的东西和view3D对象
          console.log(result)
          console.log(this.app_)
          console.log(this.viewer3D_)
        })
      })
    },
    successCallback (viewMetaData) {
      return new Promise((resolve, reject) => {

        if (viewMetaData.viewType === '3DView') {
          // 获取DOM元素
          let dom4Show = document.getElementById('domId')
          let webAppConfig = new Glodon.Bimface.Application.WebApplication3DConfig()
          webAppConfig.domElement = dom4Show
          // 创建WebApplication
          let app = new Glodon.Bimface.Application.WebApplication3D(webAppConfig)
          // 添加待显示的模型
          app.addView(this.global.viewToken)
          let _self = this
          // 监听添加view完成的事件
          app.addEventListener(Glodon.Bimface.Application.WebApplication3DEvent.ViewAdded, () => {
            let viewer3D = app.getViewer()
            _self.viewer3D_ = viewer3D
            _self.app_ = app
            viewer3D.showViewHouse()
            viewer3D.toggleContextMenuDisplay(true)
            // 渲染3D模型
            app.render()
            // databagId，二级弹窗用
            const databagId = viewer3D._getMetaDataManager()._config.databagId
            resolve({
              databagId: databagId,
              viewer3D: viewer3D,
              app: app
            })
          })
          // 监听添加view进行中的时间，可获取添加进度
          app.addEventListener(Glodon.Bimface.Application.WebApplication3DEvent.ViewLoading, function (progress) {
            // console.log(progress);
          })
          return
        }
        if (viewMetaData.viewType === 'dwgView') {

          // ======== 判断是否为2D图纸 ========
          // 获取DOM元素
          let dom4Show = document.getElementById('domId')
          let webAppConfig = new Glodon.Bimface.Application.WebApplication2DConfig()
          webAppConfig.domElement = dom4Show
          // 创建WebApplication
          let app = new Glodon.Bimface.Application.WebApplication2D(webAppConfig)

          // 添加待显示的图纸
          app.load(this.global.viewToken)

          // 从WebApplication获取viewer2D对象
          let viewer2D = app.getViewer()

          // 调用viewer2D对象的Method，可以继续扩展功能
          // your code

          // 保存databagId，二级弹窗用
          const databagId = viewer2D._getMetaDataManager()._config.databagId
          resolve({
            databagId: databagId,
            viewer2D: viewer2D,
            app: app
          })
          return
        }
        if (viewMetaData.viewType === 'drawingView') {

          // ======== 判断是否为2D图纸 ========
          // 获取DOM元素
          let dom4Show = document.getElementById('domId')
          let webAppConfig = new Glodon.Bimface.Application.WebApplicationDrawingConfig()
          webAppConfig.domElement = dom4Show
          // 创建WebApplication
          let app = new Glodon.Bimface.Application.WebApplicationDrawing(webAppConfig)

          // 添加待显示的图纸
          app.load(this.global.viewToken)

          // 从WebApplication获取viewer2D对象
          let viewer2D = app.getViewer()

          // 调用viewer2D对象的Method，可以继续扩展功能
          // your code

          // 保存databagId，二级弹窗用
          const databagId = viewer2D._getMetaDataManager()._config.databagId
          resolve({
            databagId: databagId,
            viewer2D: viewer2D,
            app: app
          })
          return
        }
        if (viewMetaData.viewType === 'rfaView') {
          // ======== 判断是否为族文件 ========
          // 获取DOM元素
          let dom4Show = document.getElementById('domId')
          // 配置参数
          let config = new Glodon.Bimface.Application.WebApplicationRfaConfig()
          config.enableExplosion = true
          config.domElement = dom4Show
          // 创建viewer3D对象
          let app = new Glodon.Bimface.Application.WebApplicationRfa(config)
          // 添加模型
          app.addView(this.global.viewToken)
          // 监听添加view完成的事件
          app.addEventListener(Glodon.Bimface.Application.WebApplicationRfaEvent.ViewAdded, function () {

            let viewer = app.getViewer()
            // 渲染3D模型
            viewer.render()
            // 保存databagId，二级弹窗用
            const databagId = viewer._getMetaDataManager()._config.databagId
            resolve({
              databagId: databagId,
              viewer3D: viewer,
              app: app
            })

          })

        }

      })
    }
  },
  watch: {
    global: {
      handler (newObj, oldObj) {
        this.renderModel()
      },
      deep: true
    }
  },
  mounted () {
    this.global = Object.assign({}, this.global, this.query)
    // this.fileName = this.global.fileName;
    // this.renderModel();
  }
}
</script>

<style lang="less" scoped>
.model-css{
  position: absolute;
  top: 45px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}
</style>
